const STAFF_NAMES = Object.freeze({
  staff_1_3: 'staff_1_3',
  staff_4_6: 'staff_4_6',
  staff_7_10: 'staff_7_10',
  staff_11_plus: 'staff_11_plus',
});

export default STAFF_NAMES;
